module.exports = __webpack_public_path__ + "img/socials-3.212acaff.png";